module.exports = __webpack_public_path__ + "static/media/cvc-error.0ff0ed5b.svg";